import React from 'react';
import {convertISODateTimeToBRLocale} from "../../../common/Util";


const ReactHighcharts = require('react-highcharts');
//var Moment = require('moment-timezone');
//require('moment/locale/pt-br');

class AutoclaveCicloGraficoEventos extends React.Component {
    constructor(props) {
        super(props);
        this.state={};
    };


    componentDidMount(){
        //   this.props.getItensManual();

    }

    componentDidUpdate(oldProps, oldState){

      //  console.log('didUpdate')
    }




    render() {
        const { ciclo } = this.props;
        const { isOpen } = this.state;

//        console.log("indicador ciclo", ciclo);

        if (!ciclo || ciclo.length < 1) { return null; }



        var chartdata = {
            chart: {
                type: 'line',
                zoomType: 'x',
                animation: false
            },
            legend: {
                enabled : false
            },
            title: {
                text: ''
            },
            plotOptions: {
                line: {
                    turboThreshold: 0,
                    marker: {
                        enabled: true,
                        radius: 2
                    }
                }
            },
            xAxis: {
                categories: ciclo.categoria,
                title: {
                    text: 'Tempo em minutos do Processo - Vulcanização - '
                }
            },
            yAxis: {
                tickInterval: 1,
                min:0,
                max:11,
                tickmarkPlacement: 'on',

                minorTickLength: 1,
                minorTickWidth: 1,
                labels: {
                    step: 1,
                    formatter: function() {
                        return this.value;
                    }
                },
                title: {
                    text : ''
                },
                categories:[
                    'Evento',
                    'Processo Iniciado',
                    'Fim de ciclo',
                    'Ventilador',
                    'Descarga Saco Ar',
                    'Descarga Envelope',
                    'Descarga Autoclave',
                    'Aquecimento',
                    'Saco de Ar',
                    'Envelope',
                    'Ar Autoclave',
                    'Porta'
                ]
            },
            series : [
                {
                    name : "Porta",
                    data : ciclo.portaAutoclave
                },
                {
                    name : "Autoclave Ventilação",
                    data : ciclo.alimentacaoArAutoclave
                },
                {
                    name : "Envelope",
                    data : ciclo.alimentacaoEnvelope
                },
                {
                    name : "Saco Ar",
                    data: ciclo.alimentacaoSacoDeAr
                },
                {
                    name : "Aquecimento",
                    data: ciclo.alimentacaoVapor
                },
                {
                    name : "Descarga Ar",
                    data: ciclo.descargaDeAr
                },
                {
                    name : "Descarga Envelope",
                    data: ciclo.descargaEnvelope
                },
                {
                    name : "Descarga Saco Ar",
                    data: ciclo.descargaSacoDeAr
                },
                {
                    name : "Ventilador",
                    data: ciclo.ventilador
                },
                {
                    name : "Fim Ciclo",
                    data: ciclo.fimDeCiclo
                },
                {
                    name : "Processo Iniciado",
                    data: ciclo.processoIniciado
                }


            ]
        }


        return (
            <React.Fragment>

                <ReactHighcharts config = {chartdata}></ReactHighcharts>


            </React.Fragment>
        )
    }
}



export default AutoclaveCicloGraficoEventos

